import React, { useState } from 'react';
import ClayModal, { useModal } from '@clayui/modal';
import ClayPanel from '@clayui/panel';
import ClayForm from '@clayui/form';
import { ClayInput } from '@clayui/form';
import ClayIcon from '@clayui/icon';
import ClayAlert from '@clayui/alert';
import ClayButton from '@clayui/button';
import {saveMessages} from "../helpers/saveMessages";

export const spritemap = window.location.protocol + '//' + window.location.host + '/o/classic-theme/images/clay/icons.svg';

export const ImportMessages = ({ useImportModal}) => {

    const { importModal, setImportModal } = useImportModal();

    const { observer, onClose } = useModal({
        onClose: () => setImportModal({ ...setImportModal, visible: false })
    });

    const [showAlert, setShowAlert] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        const importMsjJSon = document.getElementById('importMsjJSon').value;

        saveMessages(importModal.formCode, importMsjJSon).then(myobjet => {
            setImportModal({ ...setImportModal, visible: false })
        });
    };

    return (
        <>
            {
                importModal.visible && (
                    <ClayModal
                        observer={observer}
                        size="lg"
                        spritemap={spritemap}
                        status="info" >
                        <form id="formUpdateChild" onSubmit={handleSubmit}>
                            <input type="hidden" name="parentCode" defaultValue={importModal.data.parentCode} />
                            <input type="hidden" name="idChild" defaultValue={importModal.data.idChild} />
                            <ClayModal.Body style={{maxHeight: "85vh"}}>
                                <ClayPanel
                                    collapsable
                                    displayTitle="Mensajes"
                                    displayType="secondary"
                                    spritemap={spritemap}
                                    defaultExpanded >
                                    <ClayPanel.Body>
                                        <ClayForm.Group>
                                            <ClayInput.Group>
                                                <ClayInput.GroupItem>
                                                    <label htmlFor="importMsjJSon">JSON
                                                        <span className="reference-mark">
                                                                    <ClayIcon spritemap={window.$spritemap} symbol="asterisk" />
                                                                </span>
                                                    </label>
                                                    <ClayInput component={'textarea'} type="text" name='importMsjJSon' id='importMsjJSon' required />
                                                </ClayInput.GroupItem>
                                            </ClayInput.Group>
                                        </ClayForm.Group>
                                    </ClayPanel.Body>
                                </ClayPanel>
                            </ClayModal.Body>
                            <ClayModal.Footer
                                first={
                                    <ClayButton.Group spaced>
                                        <ClayButton onClick={onClose} displayType="secondary">{"Cancelar"}</ClayButton>
                                    </ClayButton.Group>
                                }
                                last={<ClayButton type="submit">{"Guardar"}</ClayButton>}
                            />
                        </form>
                        <ClayAlert.ToastContainer>
                            {showAlert && (
                                <ClayAlert
                                    displayType="success"
                                    autoClose="500"
                                    key={Math.random() * 100}
                                    spritemap={spritemap}
                                    onClose={() => setShowAlert(false)}
                                >
                                    Modificado de manera correcta.
                                </ClayAlert>
                            )}
                        </ClayAlert.ToastContainer>
                    </ClayModal>
                )
            }
        </>
    )
}